import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, {
  formatLatexPreview,
} from "../../../../components/inputs/FractionInput";

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomFrom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function generateTask() {
  const solid = randomFrom([
    "graniastosłup prawidłowy sześciokątny",
    "ostrosłup prawidłowy trójkątny",
    "kula",
  ]);
  const k = randInt(2, 4);
  const p1 = randInt(12, 64);
  const p2 = p1 * k * k;
  const v1 = randInt(10, 70);
  const v2 = v1 * k * k * k;

  return {
    type: "SimilarSolidAreaFromVolumeScaleTask",
    data: { solid, k, p1, p2, v1, v2 },
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.6 }}>
      <p>
        Dwie bryły podobne mają kształt: <strong>{data.solid}</strong>.
      </p>
      <p>
        Objętość pierwszej bryły to{" "}
        <InlineMath math={`${data.v1}\\,\\text{cm}^3`} />, a drugiej{" "}
        <InlineMath math={`${data.v2}\\,\\text{cm}^3`} />.
      </p>
      <p>
        Pole powierzchni pierwszej bryły wynosi{" "}
        <InlineMath math={`${data.p1}\\,\\text{cm}^2`} />.
      </p>
      <p>Oblicz pole powierzchni drugiej bryły.</p>
    </div>
  );
}

export function renderInput(_task, userAnswer = {}, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="P_2"
      suffixLatex={String.raw`\text{cm}^2`}
      placeholder="np. 196"
    />
  );
}

export function checkAnswer(task, userAnswer) {
  const parsed =
    userAnswer && typeof userAnswer === "object" ? userAnswer.parsed : NaN;
  if (!Number.isFinite(parsed)) return { correct: false };
  return { correct: Math.abs(parsed - task.data.p2) < 0.01 };
}

export function renderAnswer({ data }) {
  return <InlineMath math={`P_2=${data.p2}\\,\\text{cm}^2`} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return (
    <InlineMath
      math={`${formatLatexPreview(userAnswer.raw, "P_2")}\\,\\text{cm}^2`}
    />
  );
}

export function renderExplanation({ data }) {
  const ratioV = data.v2 / data.v1;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1:</strong> Dla brył podobnych:
      </p>
      <BlockMath math={`\\frac{V_2}{V_1}=k^3`} />
      <BlockMath math={`k=\\sqrt[3]{\\frac{V_2}{V_1}}=\\sqrt[3]{\\frac{${data.v2}}{${data.v1}}}=\\sqrt[3]{${ratioV}}=${data.k}`} />
      <p>
        <strong>Krok 2:</strong> Skala pól powierzchni to <InlineMath math={"k^2"} />:
      </p>
      <BlockMath math={`P_2=P_1\\cdot k^2=${data.p1}\\cdot ${data.k}^2=${data.p2}\\,\\text{cm}^2`} />
    </div>
  );
}

